import React from 'react';
import './TournamentTypeFlag.css';

const TournamentTypeFlag = ({ tournamentType }) => {
  const getFlag = (type) => {
    switch (type) {
      case 'americano':
        return '🇺🇸';
      case 'mexicano':
        return '🇲🇽';
      default:
        return null;
    }
  };

  const flag = getFlag(tournamentType);
  
  if (!flag) {
    return null;
  }

  return (
    <span 
      className="tournament-type-flag" 
      title={`Tournament type: ${tournamentType}`}
      style={{ 
        marginRight: '8px',
        fontSize: '1.2em'
      }}
    >
      {flag}
    </span>
  );
};

export default TournamentTypeFlag;
